import { Node, mergeAttributes } from '@tiptap/core';

// an org-authored placeholder chip like the custom variable, but its value is
// typed in by the customer on the signing page instead of by staff
export const SignerFieldNode = Node.create({
  name: 'signerField',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      name: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-signer-field') || '',
        renderHTML: (attributes) => ({ 'data-signer-field': attributes.name }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-signer-field]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, { class: 'agreement-signer-field' }),
      node.attrs.name || 'Signer Field',
    ];
  },
});

// mirrors CollectSignerFields in backend/app/utils/rentals_pdf — the signer
// field names of a template, in order and without duplicates
export function collectSignerFields(template: string): string[] {
  if (!template) {
    return [];
  }
  let document: any;
  try {
    document = JSON.parse(template);
  } catch {
    return [];
  }
  const names: string[] = [];
  const seen = new Set<string>();
  const walk = (node: any) => {
    if (!node) {
      return;
    }
    if (node.type === 'signerField') {
      const name = node.attrs?.name || '';
      if (name && !seen.has(name)) {
        seen.add(name);
        names.push(name);
      }
    }
    (node.content || []).forEach(walk);
  };
  walk(document);
  return names;
}
